export const META_DATA_REQUEST : string = 'META_DATA_REQUEST'
export const META_DATA_SUCCESS : string = 'META_DATA_SUCCESS'
export const META_DATA_FAIL : string = 'META_DATA_FAIL'
